import React from 'react';
import StyledFirebaseAuth from 'react-firebaseui/StyledFirebaseAuth';
import firebase from 'firebase';
import {AuthConsumer} from '../../Context/AuthContext';

export default function SignIn(props) {
    const [isSignedIn, setIsSignedIn] = React.useState(false);

    const uiConfig = {
        signInFlow: 'popup',
        signInOptions: [
          firebase.auth.EmailAuthProvider.EMAIL_PASSWORD_SIGN_IN_METHOD
        ],
        signInSuccessUrl: "/admin",
        callbacks: {
        }
      };
    
    return (
        <AuthConsumer>
            {(props) => {
                return <StyledFirebaseAuth uiConfig={uiConfig} firebaseAuth={firebase.auth()}/>
            }}
        </AuthConsumer>
    )
}